import { Pipe, PipeTransform } from '@angular/core';
import { SpsLogger } from '@lib/utils';
import { environment } from '../../../environments/environment.prod.prod-live';

// Temporarily fix for SPSCR-328, needs to be fixed in the CMS

@Pipe({
  name: 'urlFixed',
  standalone: true,
})
export class UrlFixedPipe implements PipeTransform {
  static instance: UrlFixedPipe;

  static transform(src: string): string {
    return this.getInstance().transform(src);
  }

  static getInstance(): UrlFixedPipe {
    return (this.instance ||= new UrlFixedPipe());
  }

  private readonly legacyCmsHost = 'https://swisspostsolutionscms.prod.sites.dropsolid-sites.com';
  private readonly regex = /spsglobal.com(\/(?:en|de)\/sites)\/default\/files\/.+\.pdf/;

  transform(src: string = null): string | null {
    if (!src) {
      return src ?? null;
    }

    const prodLiveHost = environment.apiHost;

    if (src.toLowerCase().startsWith(this.legacyCmsHost)) {
      // href / url etc...
      try {
        const url = new URL(src);
        url.host = prodLiveHost.split('https://')[1];
        src = url.toString();
      } catch (e) {
        SpsLogger.warn(e);
      }
    } else if (src.includes(this.legacyCmsHost)) {
      // free text html including <a href
      try {
        src = src.replaceAll(this.legacyCmsHost, prodLiveHost);
      } catch (e) {
        SpsLogger.log(e);
      }
    }

    if (!this.regex.test(src)) {
      return src;
    }

    try {
      const match = this.regex.exec(src)?.[1];
      return src.replaceAll(match, '/sites');
    } catch (e) {
      SpsLogger.warn(e);
      return src;
    }
  }
}
